export const WEEKDAYS = {
	SUNDAY: 0,
	MONDAY: 1,
}

export const WEEK_START_MONDAY = { firstDayOfWeek: WEEKDAYS.MONDAY }
